module.exports = __webpack_public_path__ + "img/finland-cancer-female.e0e40a77.png";